export default __webpack_public_path__ + "static/media/bizz_website.fb422895.svg";